import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<{
	default: [
		'gettingStarted',
		'startTour',
		'back',
		'next',
		'done',
		'stepIndicator',
		'step1Headline',
		'step1Body',
		'step2Headline',
		'step2Body',
		'step3Headline',
		'step3Body',
		'step4Headline',
		'step4Body',
		'close',
	];
}> = defineContent({
	default: {
		gettingStarted: {
			id: 'rovo-agents.scenario-onboarding.gettingStarted',
			defaultMessage: 'Getting started with your agent',
			description: 'Getting started with your agent',
			role: 'title',
		},
		startTour: {
			id: 'rovo-agents.scenario-onboarding.startTour',
			defaultMessage: 'Start Tour',
			description: 'Start tour button label in onboarding spotlight',
		},
		back: {
			id: 'rovo-agents.scenario-onboarding.backButton',
			defaultMessage: 'Back',
			description: 'Back button label in onboarding spotlight',
		},
		next: {
			id: 'rovo-agents.scenario-onboarding.nextButton',
			defaultMessage: 'Next',
			description: 'Next button label in onboarding spotlight',
		},
		done: {
			id: 'rovo-agents.scenario-onboarding.doneButton',
			defaultMessage: 'Done',
			description: 'Done button label in onboarding spotlight',
		},
		stepIndicator: {
			id: 'rovo-agents.scenario-onboarding.stepIndicator',
			defaultMessage: '{currentStep} of {totalSteps}',
			description: 'Step indicator of onboarding spotlight',
		},
		step1Headline: {
			id: 'rovo-agents.scenario-onboarding.step1Headline',
			defaultMessage: 'Tune your agent to each situation',
			description: 'Headline for step 1 in scenario onboarding',
		},
		step1Body: {
			id: 'rovo-agents.scenario-onboarding.step1Body',
			defaultMessage:
				'Scenarios allow you to instruct your agent to do things differently depending on the situation.',
			description: 'Body text for step 1 in scenario onboarding',
			role: 'description',
		},
		step2Headline: {
			id: 'rovo-agents.scenario-onboarding.step2Headline',
			defaultMessage: "Set your agent's traits and goals",
			description: 'Headline for step 2 in scenario onboarding',
		},
		step2Body: {
			id: 'rovo-agents.scenario-onboarding.step2Body',
			defaultMessage:
				'Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.',
			description: 'Body text for step 2 in scenario onboarding',
		},
		step3Headline: {
			id: 'rovo-agents.scenario-onboarding.step3Headline',
			defaultMessage: 'See what your agent knows',
			description: 'Headline for step 3 in scenario onboarding',
		},
		step3Body: {
			id: 'rovo-agents.scenario-onboarding.step3Body',
			defaultMessage:
				"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.",
			description: 'Body text for step 3 in scenario onboarding',
		},
		step4Headline: {
			id: 'rovo-agents.scenario-onboarding.step4Headline',
			defaultMessage: 'See what your agent can do',
			description: 'Headline for step 4 in scenario onboarding',
		},
		step4Body: {
			id: 'rovo-agents.scenario-onboarding.step4Body',
			defaultMessage:
				"You can add skills to your agent's scenarios so it can connect and take action across apps.",
			description: 'Body text for step 4 in scenario onboarding',
		},
		close: {
			id: 'rovo-agents.scenario-onboarding.close.no-translate',
			defaultMessage: 'Close',
			description: 'Accessible label for closing the onboarding banner.',
		},
	},
});
